var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.4,
    height: 96.14,
    viewBox: "0 0 53.4 96.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006027;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734.67 -63.86)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M761.37,160a26.7,26.7,0,1,1,26.7-26.7A26.733,26.733,0,0,1,761.37,160Zm0-49.39a22.7,22.7,0,1,0,22.7,22.7A22.728,22.728,0,0,0,761.37,110.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M786.07,63.86h-49.4a2.006,2.006,0,0,0-2,2V88.31a1.992,1.992,0,0,0,.69,1.51l23.29,20.3a4.854,4.854,0,0,1,4.13.49,1.978,1.978,0,0,0,1.31-.49l23.29-20.3a1.991,1.991,0,0,0,.69-1.51V65.86A2.006,2.006,0,0,0,786.07,63.86Zm-2,23.54-22.6,19.7c-.04.03-.06.07-.1.1a.947.947,0,0,0-.1-.1l-22.6-19.7V67.86h11.55V88.01a2,2,0,0,0,4,0V67.86h14.3V88.01a2,2,0,0,0,4,0V67.86h11.55V87.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.8cda327f2a911c4bb750e46c62f7a7dc.svg";
export { ForwardRef as ReactComponent };